"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ThemeStore = _interopRequireDefault(require("./ThemeStore2"));

var ThemeActions = /*#__PURE__*/function () {
  function ThemeActions() {
    (0, _classCallCheck2["default"])(this, ThemeActions);
  }

  (0, _createClass2["default"])(ThemeActions, null, [{
    key: "addTheme",
    value: function addTheme(theme) {
      _ThemeStore["default"].addTheme(theme);
    }
  }, {
    key: "resetTheme",
    value: function resetTheme() {
      _ThemeStore["default"].resetTheme();
    }
  }]);
  return ThemeActions;
}();

var _default = ThemeActions;
exports["default"] = _default;